module.exports = __webpack_public_path__ + "static/p1-363fcf5263ccbe055c2403f89016161d.jpg";